export const DEFAULT_REQUEST_OPTIONS_TIMEOUT = 5000
export const DEFAULT_CMS_TIMEOUT = 10000
